import { IRecord, IRecordType } from 'annotation-tools/utils';
import { ProjectStatus } from '../enum/project-status';

// immutable object generator
export const IProject = IRecord<ProjectType>({
  id: 0,
  name: '',
  companyId: 0,
  status: 'unapproved',
  author: '',
  approver: '',
  canBeDeleted: false,
  dateCreated: Date.now(),
  dateUpdated: Date.now()
});

// immutable type
export type IProjectType = IRecordType<ProjectType>;

type ProjectType = {
  id: number;
  name: string; // [1..50] characters
  companyId: number;
  status: ProjectStatus;
  author: string;
  approver: string;
  canBeDeleted: boolean;
  dateCreated: number;
  dateUpdated: number;
};
